import gql from 'graphql-tag';

const createDealershipBlacklistMutation = gql`
  mutation createDealershipBlacklist($input: CreateDealershipBlacklistInput!) {
    createDealershipBlacklist(input: $input) {
      success
      errors
    }
  }
`;

export default createDealershipBlacklistMutation;
